export default __webpack_public_path__ + "static/media/meenakshi.01fe3068.jpg";